var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[(_vm.reviewingOrder ? 'open' : '', 'sidebar-cart'),
           (_vm.guestCheckout ? true : '', 'guest-checkout')]},[_c('h4',[_vm._v(_vm._s(_vm.$t('cart.yourItems')))]),_vm._v(" "),(_vm.reviewingOrder)?_c('Cart'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }